import React, { useEffect, useState } from 'react'
import { AuthoringUtils } from '@adobe/aem-spa-page-model-manager'
import { fetchModel, ModelProps } from '@adobe/aem-react-editable-components'
import Iframe from '../Iframe/Iframe'
import Container from '../Container/Container'
import {
  ContainerChildrenModelProps,
  ExperienceFragmentContentModelProps
} from './types'

const ExperienceFragmentContent: React.FC<
  ExperienceFragmentContentModelProps
> = ({ ...props }) => {
  const { xfContent = null, xfPath, id } = props.model
  const [content, setContent] = useState<(ModelProps & ContainerChildrenModelProps) | null
  >(xfContent)
  useEffect(() => {
    if (content === null && !AuthoringUtils.isInEditor()) {
      const fetchXfData = async () => {
        const modelContent = await fetchModel({
          cqPath: xfPath
        })
        if (modelContent !== null) {
          setContent(modelContent)
        }
      }
      fetchXfData()
    }
  }, [content])

  const adaptedContent = content
    ? {
        ...content,
        cqItems: content?.[':items'],
        cqItemsOrder: content?.[':itemsOrder'],
        cqType: content?.[':type']
      }
    : {}

  return AuthoringUtils.isInEditor() ? (
    <Iframe
      key={xfPath}
      model={{
        title: 'xf-content-title',
        name: 'xf-content-name',
        id,
        url: `${xfPath}.html`,
        isAdaptedToContent: true
      }}
    />
  ) : (
    <Container model={{ id, ...adaptedContent }} />
  )
}

export default ExperienceFragmentContent
